import { Download, Eye, MoreVertical } from "react-feather";
import {
  Fade,
  Menu,
  MenuItem,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { FranchiseDocumentType } from "@hubcapp/views/MyDetails/types";
import Button from "@ds-developer/button";
import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import clsx from "clsx";

interface Props {
  rowData: FranchiseDocumentType;
}

const useStyles = makeStyles(() => ({
  customTooltip: {
    fontSize: 10,
    fontWeight: 500,
    padding: "4px 8px",
    lineHeight: "20px",
  },
  customBtn: {
    minWidth: "unset",
    "& span": {
      display: "flex",
    },
  },
  tabPanelWithTable: {
    paddingTop: 24,
    paddingBottom: 0,
    "& .MuiPaper-elevation1": {
      boxShadow: "none",
    },
  },
  tabsPanel: {
    marginRight: 16,
    marginLeft: 16,
  },
  tableRow: {
    "&.mobileTableRow *": {
      fontSize: "12px !important",
      maxWidth: "170px",
      // whiteSpace: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
    },
  },
  menuItem: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    textTransform: "uppercase",
    "& span": {
      fontSize: "14px",
    },
  },
}));

export const TableCellActions: React.FC<Props> = ({ rowData }) => {
  const classes = useStyles();
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down("sm"));
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const downloadFile = (link: string, filename: string): void => {
    fetch(link)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      });
  };

  return (
    <>
      {mobileDevice ? (
        <>
          <Button className={clsx(classes.customBtn)} onClick={() => {}}>
            <Tooltip
              title="Upload"
              classes={{ tooltip: classes.customTooltip }}
              onClick={handleClick}
            >
              <MoreVertical size={16} />
            </Tooltip>
          </Button>
          <Menu
            id="fade-menu"
            anchorEl={anchorEl}
            keepMounted
            open={open}
            onClose={handleClose}
            TransitionComponent={Fade}
          >
            <MenuItem
              onClick={() => {
                window.open(rowData.url, "_blank");
                handleClose();
              }}
              className={classes.menuItem}
            >
              <Eye size={16} /> <span>View</span>
            </MenuItem>
            <MenuItem
              onClick={() => {
                downloadFile(rowData.url, rowData.documentType);
                handleClose();
              }}
              className={classes.menuItem}
            >
              <Download size={16} /> <span>Download</span>
            </MenuItem>
          </Menu>
        </>
      ) : (
        <>
          <Button
            className={clsx(classes.customBtn)}
            onClick={() => window.open(rowData.url, "_blank")}
          >
            <Tooltip title="View" classes={{ tooltip: classes.customTooltip }}>
              <Eye />
            </Tooltip>
          </Button>
          <Button
            className={clsx(classes.customBtn)}
            onClick={() => downloadFile(rowData.url, rowData.documentType)}
          >
            <Tooltip
              title="Download"
              classes={{ tooltip: classes.customTooltip }}
            >
              <Download />
            </Tooltip>
          </Button>
        </>
      )}
    </>
  );
};
